@if (isLoading) {
    <loading [isLoading]="isLoading" [success]="true"></loading>
} @else {
    @if (authSession) {
        <div class="flex flex-col gap-2 sm:pt-4">
            <div class="flex flex-col gap-2 p-2">
                <div class="font-bold border-slate-300 border-b">
                    General Settings
                </div>
                <div class="flex flex-col gap-2 text-sm">
                    <user-avatar-change [authSession]="authSession"></user-avatar-change>
                    <user-display-name-change [authSession]="authSession"></user-display-name-change>
                    <user-username-change [authSession]="authSession"></user-username-change>
                    <user-type-change [authSession]="authSession"></user-type-change>
                    <div class="flex flex-col gap-2">
                        <div class="font-bold">
                            Account Limits
                        </div>
                        <ul class="list-disc pl-8">
                            <li>Collection - Unique Items: {{ collectionUniqueLimit | number }}</li>
                            <li>Decks - Count: {{ deckCountLimit | number }}</li>
                        </ul>
                    </div>
                </div>
                <div class="font-bold border-slate-300 border-b pt-4">
                    Privacy Settings
                </div>
                <user-privacy-settings-change [authSession]="authSession"></user-privacy-settings-change>
            </div>
        </div>
    } @else {
        <unauthorized></unauthorized>
    }
}